module.exports = __webpack_public_path__ + "static/img/down-logo.b77c60f.png";


//////////////////
// WEBPACK FOOTER
// ./static/down-logo.png
// module id = hSg1
// module chunks = 1